if (!window.initParams) {
	window.initParams = {};
}
let LOAN_AMOUNT_CEIL = window.initParams.hitelosszegMaximum || 50000000;
let LOAN_AMOUNT_INITIAL = window.initParams.hitelosszegAlapertek || 5000000;
const LOAN_AMOUNT_FLOOR = window.initParams.hitelosszegMinimum || 500000;
const LOAN_AMOUNT_STEP = window.initParams.hitelosszegLepeskoz || 100000;
const LOAN_YEARS_FLOOR = window.initParams.futamidoMinimum || 5;
const LOAN_YEARS_CEIL = window.initParams.futamidoMaximum || 20;
const LOAN_YEARS_INITIAL = window.initParams.futamidoAlapertek || 15;
const NETTO_SALARY = window.initParams.nettoJovedelmek || false;
const NEWLY_BUILT = 'newlyBuilt';
const FOR_NEW_PROPERTY = window.initParams.hitelcelUj || 'cel_uj_vasarlas';
const FOR_NOT_NEW_PROPERTY = window.initParams.hitelcel || 'cel_hasznalt_vasarlas';
const LAHI_IDS_UJ = window.initParams.lahiIdUj.split(',');
const LAHI_IDS = window.initParams.lahiId.split(',');
const PRODUCT_ID = window.initParams.productId || 100;
const QUESTION_ID = window.initParams.questionId || 1;
const EIGHTY_PERCENT = 0.8;
window.lahiParams = {};

let vm;
export const loanCalculatorComponent = {
	bindings: {
		realEstatePrice: '<',
		condition: '<'
	},
	transclude: true,
	templateUrl: 'loan-calculator.html',
	controllerAs: 'loan',
	controller: class loanCalculatorComponent {
		constructor($scope, loanService, loaderService, notificationService, scrollToElement, $mdDialog, $timeout, $compile) {
			'ngInject';
			this.$scope = $scope;
			this.loanService = loanService;
			this.loader = loaderService;
			this.notificationService = notificationService;
			this.nettoSalaryValues = NETTO_SALARY;
			this.errorOnLoan = false;
			this.nettoSalary = null;
			this.scrollToElement = scrollToElement;
			this.$mdDialog = $mdDialog;
			this.lahiPurposes = {
				notNewProperty: FOR_NOT_NEW_PROPERTY,
				newProperty: FOR_NEW_PROPERTY
			};
			this.$timeout = $timeout;
			this.PRODUCT_ID = PRODUCT_ID;
			this.QUESTION_ID = QUESTION_ID;
			this.$compile = $compile;
			vm = this;
		}

		$onChanges(changes) {
			if (changes.realEstatePrice && this.realEstatePrice) {
				this.estatePrice = angular.copy(this.realEstatePrice);
				LOAN_AMOUNT_CEIL = Math.min(LOAN_AMOUNT_CEIL, Math.floor((this.estatePrice * EIGHTY_PERCENT) / LOAN_AMOUNT_STEP) * LOAN_AMOUNT_STEP);
				LOAN_AMOUNT_INITIAL = LOAN_AMOUNT_CEIL;
				this.initLoanAmountSlider();
			}
			if (changes.condition && this.condition) {
				this.conditionOfProperty = angular.copy(this.condition);
			}
		}

		$onInit() {
			this.startRerender();
			if (!this.initialized) {
				this.initSliders();
				angular.element(document).on('formAvailable', () => {
					vm.setPayloadToVhk();
				});
				this.initialized = true;
			}
			this.$timeout(() => {
				this.$scope.$broadcast('rzSliderForceRender');
			}, 3000);
			this.initVhk();
		}
		initVhk() {
			const event = new CustomEvent('call-request-init');
			window.dispatchEvent(event);
		}
		initForm() {
			const event = new CustomEvent('call-request-init-form', { detail: { id: 'call-request-ip' } });
			window.dispatchEvent(event);

		}
		resetForm() {
			const event = new CustomEvent('call-request-reset-form', { detail: { id: 'call-request-ip' } });
			window.dispatchEvent(event);
		}
		startRerender() {
			if (angular.element('div.rzslider').length) {
				this.$scope.$broadcast('rzSliderForceRender');
			} else {
				this.$timeout(() => {
					this.startRerender();
				}, 500);
			}
		}

		getLoanData(callback) {
			this.zeroResult = false;
			this.firstLoan = false;
			window.lahiParams = {
				amount: this.loanAmountSliderModel,
				duration: this.loanYearsSliderModel,
				lahiPurpose: this.conditionOfProperty == NEWLY_BUILT ? FOR_NEW_PROPERTY : FOR_NOT_NEW_PROPERTY,
				lahiIds: this.conditionOfProperty == NEWLY_BUILT ? LAHI_IDS_UJ : LAHI_IDS
			};
			if (this.wage) {
				window.lahiParams.wage = this.wage;
			}
			this.errorOnLoan = false;
			this.disableButton = true;
			this.loanService.getLoanResult(window.lahiParams).then(
				response => {
					this.disableButton = false;
					if (typeof callback == 'function') {
						callback();
					}
					this.loanInfo = response.data;
					this.firstLoan = !angular.equals({}, response.data) ? response.data : false;
					if (!this.firstLoan) {
						this.zeroResult = true;
					}
					window.lahiParams.hosszuNev = this.firstLoan ? this.firstLoan.hosszuNev : '';
					window.dataLayer.push({
						event: 'loanCalculatorResult',
						loanAmount: this.loanAmountSliderModel,
						loanMaturity: this.loanYearsSliderModel
					});
				},
				() => {
					this.disableButton = false;
					if (typeof callback == 'function') {
						callback();
					}
					this.errorOnLoan = true;
					this.initSliders();
					this.notificationService.showError({
						message: 'technicalError'
					});
				}
			);
		}

		initSliders() {
			this.initLoanAmountSlider();
			this.initLoanYearsSlider();
		}

		loanAmountSliderChanged(val) {
			this.loanAmountModel = val;
			this.loanAmountSliderModel = val;
		}

		loanAmountChanged() {
			if (typeof this.loanAmountModel != 'number' || isNaN(this.loanAmountModel)) {
				this.loanAmountModel = LOAN_AMOUNT_INITIAL;
			}
			this.loanAmountModel = parseInt(this.loanAmountModel / LOAN_AMOUNT_STEP, 10) * LOAN_AMOUNT_STEP;
			if (this.loanAmountModel < LOAN_AMOUNT_FLOOR) {
				this.loanAmountModel = LOAN_AMOUNT_FLOOR;
			}
			if (this.loanAmountModel > LOAN_AMOUNT_CEIL) {
				this.loanAmountModel = LOAN_AMOUNT_CEIL;
			}
			this.loanAmountSliderModel = this.loanAmountModel;
		}

		loanYearsSliderChanged(id, val) {
			vm.loanYearsModel = val;
			vm.loanYearsSliderModel = val;
		}

		loanYearChanged() {
			if (typeof this.loanYearsModel != 'number' || isNaN(this.loanYearsModel)) {
				this.loanYearsModel = LOAN_YEARS_INITIAL;
			}
			if (this.loanYearsModel < LOAN_YEARS_FLOOR) {
				this.loanYearsModel = LOAN_YEARS_FLOOR;
			}
			if (this.loanYearsModel > LOAN_YEARS_CEIL) {
				this.loanYearsModel = LOAN_YEARS_CEIL;
			}
			this.loanYearsSliderModel = this.loanYearsModel;
		}

		initLoanAmountSlider() {
			this.loanAmountSliderModel = LOAN_AMOUNT_INITIAL;
			this.loanAmountModel = LOAN_AMOUNT_INITIAL;
			this.loanAmountSliderOptions = {
				min: LOAN_AMOUNT_FLOOR,
				max: LOAN_AMOUNT_CEIL,
				floor: LOAN_AMOUNT_FLOOR,
				ceil: LOAN_AMOUNT_CEIL,
				step: LOAN_AMOUNT_STEP,
				showTicks: false,
				showSelectionBar: true,
				onChange: function(id, val) {
					vm.$timeout(() => {
						vm.loanAmountSliderChanged(val);
					});
				}
			};
		}

		initLoanYearsSlider() {
			this.loanYearsSliderModel = LOAN_YEARS_INITIAL;
			this.loanYearsModel = LOAN_YEARS_INITIAL;
			this.loanYearsSliderOptions = {
				min: LOAN_YEARS_FLOOR,
				max: LOAN_AMOUNT_CEIL,
				floor: LOAN_YEARS_FLOOR,
				ceil: LOAN_YEARS_CEIL,
				showTicks: false,
				showSelectionBar: true,
				onChange: vm.loanYearsSliderChanged
			};
		}

		clikOnMoreInfo() {
			window.open('https://www.otpbank.hu/portal/hu/Lakashitel', '_blank');
		}

		/**
		 * VHK
		 */

		clickOnInterest(page) {
			this.$mdDialog
				.show({
					templateUrl: 'vhk-popup.html',
					clickOutsideToClose: true,
					controller: () => this,
					controllerAs: '$ctrl',
					preserveScope: true
				})
				.finally(() => {
					window.callRequestIPApi && window.callRequestIPApi.resetForm();
					this.resetForm();
					vm.$mdDialog.destroy({
						templateUrl: 'vhk-popup.html'
					});
				});

			this.$timeout(() => {
				if (window.callRequestIPApi) {
					if (!vm.initCalled) {
						window.callRequestIPApi.initCallrequest();
					}
				}
				this.initForm();
				this.setPlayloadToVhkNew();
			}, 500);
			if (window.callRequestIPApi) {
				window.callRequestIPApi.onCallRequestReady = () => {
					vm.initCalled = true;
					vm.setPayloadToVhk();
				};
			}
		}

		setPayloadToVhk() {
			if (window.callRequestIPApi) {
				let payload =
					'Hitelcél: ' +
					window.lahiParams.lahiPurpose +
					', Összeg: ' +
					window.lahiParams.amount +
					', Futamidő: ' +
					window.lahiParams.duration +
					', Termék: ' +
					window.lahiParams.hosszuNev +
					', Jövedelemkedvezmény: ' +
					window.lahiParams.discountPercentage;
				window.callRequestIPApi.setPayload(payload);
			}
		}
		setPlayloadToVhkNew() {
			let payload =
				'Hitelcél: ' +
				window.lahiParams.lahiPurpose +
				', Összeg: ' +
				window.lahiParams.amount +
				', Futamidő: ' +
				window.lahiParams.duration +
				', Termék: ' +
				window.lahiParams.hosszuNev +
				', Jövedelemkedvezmény: ' +
				window.lahiParams.discountPercentage;
			const event = new CustomEvent('call-request-ip-set-payload', { detail: payload });
			window.dispatchEvent(event);
		}
		closeVhkModal() {
			this.$mdDialog.hide();
		}
	}
};
